import api from "./axios";
import { ApiResponse } from "@/types/apiResponse";
import { AptDateParamsResponse } from "@/types/apartmentPlan";

export async function fetchAptDayParams(
  date: string
): Promise<AptDateParamsResponse> {
  const res = await api.get<ApiResponse<AptDateParamsResponse>>(
    "/apt-plan-day-params",
    {
      params: {
        date: date,
      },
    }
  );

  return res.data.data;
}
